<template>
  <div>
    <a-dropdown v-if="permission && !disabled" :trigger="['click']">
      <span class="edit-status">
        <a-tag v-if="testCaseResults[result] && result !== 5" :color="testCaseResults[result].color">{{ testCaseResults[result].label }}</a-tag>
        <a-tag v-else-if="testCaseResults[result]" :color="testCaseResults[result].color" style="color: gray; width: 40px">{{ testCaseResults[result].label }}</a-tag>
        <a-icon class="icon-down" type="down" />
      </span>
      <a-menu slot="overlay">
        <a-menu-item v-for="(item, key) in testCaseResults" :key="key" @click="onChange(item.value)">
          <a-tag v-if="item.value !== 1 && item.value !== 5" :color="item.color">{{ item.label }}</a-tag>
          <a-tag v-else :color="item.color" style="color: gray; width: 40px">{{ item.label }}</a-tag>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <span v-else>
      <a-tag v-if="testCaseResults[result] && result !== 5" :color="testCaseResults[result].color">{{ testCaseResults[result].label }}</a-tag>
      <a-tag v-else-if="testCaseResults[result]" :color="testCaseResults[result].color" style="color: gray; width: 40px">{{ testCaseResults[result].label }}</a-tag>
    </span>
  </div>
</template>
<script>
import { testCaseResults } from '@/utils/dictionary';
import { updateTestCaseResult } from '@/api/project/testPlan';

export default {
  props: {
    result: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    planId: {
      type: [String, Number],
      default: null
    },
    caseId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      testCaseResults,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  computed: {
    permission() {
      // return permissionRequired('project:requirement:status:update', this.projectId);
      return true;
    }
  },
  methods: {
    onChange(value) {
      updateTestCaseResult({ test_plan_id: this.planId, result: value, case_id: this.caseId }).then(() => {
        this.$message.success('结果更新成功');
        this.$emit('change');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.edit-status {
  cursor: pointer;
  display: inline-block;
  padding: 0 2px;
  line-height: 22px;
  .icon-down {
    opacity: 0;
  }
}
.edit-status:hover {
  cursor: pointer;
  background-color: #e4e4e4;
  .icon-down {
    opacity: 1;
  }
}
</style>
